<glxy-table-container
  class="ks-table-container"
  [columns]="columns()"
  [dataSource]="dataSource"
  [pageSize]="25"
  [pageSizeOptions]="[10, 25, 50]"
  [showFooter]="true"
>
  <glxy-table-content-header [showColumnArrange]="false" [showFilters]="false" [showSort]="false">
    @if (editingEnabled) {
      <button after-search mat-flat-button color="primary" (click)="openAddKnowledgeSourceDialog()">
        <mat-icon>add</mat-icon>
        {{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.CREATE' | translate }}
      </button>
    }
  </glxy-table-content-header>

  <table mat-table class="kb-table">
    <ng-container matColumnDef="kind">
      <th mat-header-cell *matHeaderCellDef class="ks-table__kind">{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.COL_TYPE' | translate }}</th>
      <td mat-cell *matCellDef="let row" class="ks-table__kind">
        <mat-icon [matTooltip]="row.kind">{{ iconFor(row) }}</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.COL_NAME' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <span class="ks-table__name-line">
          @if (canEditSource(row)) {
            <a href="javascript:void(0)" class="kb-table__link" (click)="openKnowledgeSourceEditor(row)">{{ row.name }}</a>
          } @else {
            <span>{{ row.name }}</span>
          }
          @if (row.hasAutoRefresh) {
            <mat-icon class="ks-table__badge-icon" color="primary" [matTooltip]="row.autoRefreshTooltip ?? ''">update</mat-icon>
          }
          @if (row.isTrainingInProgress) {
            <mat-icon class="ks-table__badge-icon" color="primary" [matTooltip]="'KNOWLEDGE_SHARING.SOURCE_TABLE.TRAINING_IN_PROGRESS' | translate">fitness_center</mat-icon>
          }
          @if (row.isSuggested) {
            <glxy-badge [size]="'small'">{{ 'SUGGESTED' | translate }}</glxy-badge>
          }
          @if (isShared(row)) {
            <mat-icon
              class="kb-table__managed-icon"
              [matTooltip]="'KNOWLEDGE_SHARING.SOURCES.MANAGED_BY' | translate: { partner: row.managedBy }"
            >lock</mat-icon>
          }
        </span>
        <div class="ks-table__sub">{{ row.subtitle }}</div>
        @if (row.lastScrapedText) {
          <div class="ks-table__sub">{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.LAST_SCRAPED' | translate: { date: row.lastScrapedText } }}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.COL_DESCRIPTION' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.description }}</td>
    </ng-container>

    <ng-container matColumnDef="lastModified">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.COL_LAST_MODIFIED' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.lastModified | date: 'mediumDate' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="kb-table__actions"></th>
      <td mat-cell *matCellDef="let row" class="kb-table__actions">
        @if (hasRowActions(row)) {
          <button
            mat-icon-button
            [matMenuTriggerFor]="ksMenu"
            [attr.aria-label]="'KNOWLEDGE_SHARING.SOURCE_TABLE.ROW_ACTIONS' | translate"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <mat-menu #ksMenu="matMenu">
          @if (editingEnabled) {
            @if (canEditSource(row)) {
              <button mat-menu-item (click)="openKnowledgeSourceEditor(row)">
                <mat-icon>edit</mat-icon>
                <span>{{ 'COMMON.EDIT' | translate }}</span>
              </button>
              @if (canRefreshSource(row)) {
                <button mat-menu-item (click)="refreshKnowledgeSource(row)">
                  <mat-icon>refresh</mat-icon>
                  <span>{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.REFRESH' | translate }}</span>
                </button>
              }
              <button mat-menu-item (click)="deleteKnowledgeSource(row)">
                <mat-icon>delete</mat-icon>
                <span>{{ 'COMMON.DELETE' | translate }}</span>
              </button>
            } @else {
              <button mat-menu-item disabled>
                <mat-icon>edit</mat-icon>
                <span>{{ 'COMMON.EDIT' | translate }}</span>
              </button>
              <button mat-menu-item disabled>
                <mat-icon>delete</mat-icon>
                <span>{{ 'COMMON.DELETE' | translate }}</span>
              </button>
            }
          }
          @if (canRemoveFromCollection(row)) {
            <button mat-menu-item (click)="removeFromCollection.emit(row)">
              <mat-icon>playlist_remove</mat-icon>
              <span>{{ 'KNOWLEDGE_SHARING.SOURCE_TABLE.REMOVE_FROM_COLLECTION' | translate }}</span>
            </button>
          }
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="[]"></tr>
    <tr mat-row *matRowDef="let row; columns: []; trackBy: trackRow" [class.kb-table__row--shared]="isShared(row)"></tr>
    <tr class="kb-table__empty" *matNoDataRow>
      <td [attr.colspan]="columns().length">
        <glxy-empty-state class="kb-table__empty-state" [size]="'small'">
          <glxy-empty-state-hero>
            <mat-icon>{{ isFiltered() ? 'search_off' : 'article' }}</mat-icon>
          </glxy-empty-state-hero>
          <glxy-empty-state-title>
            {{ (isFiltered() ? 'KNOWLEDGE_SHARING.SOURCE_TABLE.EMPTY_FILTERED_TITLE' : 'KNOWLEDGE_SHARING.SOURCE_TABLE.EMPTY_TITLE') | translate }}
          </glxy-empty-state-title>
          <p>
            {{ (isFiltered() ? 'KNOWLEDGE_SHARING.SOURCE_TABLE.EMPTY_FILTERED_DESCRIPTION' : 'KNOWLEDGE_SHARING.SOURCE_TABLE.EMPTY_DESCRIPTION') | translate }}
          </p>
        </glxy-empty-state>
      </td>
    </tr>
  </table>
</glxy-table-container>
